export default function Disabled() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] p-8" data-testid="disabled-page">
      <div className="text-center max-w-md">
        <div className="text-[10px] tracking-luxury text-[#C5B39B] uppercase mb-2">Cosmely</div>
        <h1 className="font-serif text-5xl mb-4">Prodotto non disponibile</h1>
        <p className="text-[#707070]">Il prodotto a cui stai cercando di accedere non è attualmente disponibile online. Ti invitiamo a contattare il punto vendita di riferimento.</p>
      </div>
    </div>
  );
}
